import { useState, useCallback } from 'react';

import MODAL_VIEWS from './MODAL_VIEWS';

export default function useManageSampleEventsModal({ onSampleEventChange }) {
  const [currentView, setCurrentView] = useState(MODAL_VIEWS.LIST);
  const [selectedSampleEvent, setSelectedSampleEvent] = useState(null);

  // View Navigation
  const goToEditView = useCallback(sampleEvent => {
    setSelectedSampleEvent(sampleEvent);
    setCurrentView(MODAL_VIEWS.EDIT);
  }, []);

  const goToDeleteView = useCallback(sampleEvent => {
    setSelectedSampleEvent(sampleEvent);
    setCurrentView(MODAL_VIEWS.DELETE_CONFIRM);
  }, []);

  const resetToListView = useCallback(() => {
    setCurrentView(MODAL_VIEWS.LIST);
    setSelectedSampleEvent(null);
  }, []);

  // Edit Success Handler
  const onEditSuccess = useCallback(
    ({ eventId, eventJson }) => {
      onSampleEventChange({ eventId, eventJson });
      setCurrentView(MODAL_VIEWS.LIST);
    },
    [onSampleEventChange]
  );

  return {
    currentView,
    selectedSampleEvent,
    goToEditView,
    goToDeleteView,
    goToListView: resetToListView,
    onEditSuccess,
    onDeleteSuccess: resetToListView,
    onModalClosed: resetToListView,
  };
}
